import React from 'react';
import { AnalyticsPageView } from 'src/components/Analytics';
import { Medium, LessThanMedium } from '@jg/responsive';
import DesktopEncourageShareAndDonate from './DesktopEncourageShareAndDonate';
import MobileEncourageShareAndDonate from './MobileEncourageShareAndDonate';
import { AnalyticsClick } from 'src/redux/modules/analytics';

interface Props {
  ownerName: string;
  pageName: string;
  analyticsClick: AnalyticsClick;
}

const EncourageShareAndDonate: React.StatelessComponent<Props> = ({
  ownerName,
  pageName,
  analyticsClick,
}) => {
  return (
    <AnalyticsPageView
      eventValue="donate prompt"
      pageSection="page > donate prompt"
      subtype="donate prompt"
    >
      <LessThanMedium>
        <MobileEncourageShareAndDonate
          ownerName={ownerName}
          pageName={pageName}
          analitycsClick={analyticsClick}
        />
      </LessThanMedium>
      <Medium>
        <DesktopEncourageShareAndDonate
          ownerName={ownerName}
          pageName={pageName}
          analitycsClick={analyticsClick}
        />
      </Medium>
    </AnalyticsPageView>
  );
};

export default EncourageShareAndDonate;



// WEBPACK FOOTER //
// ./src/components/EncourageShareAndDonate/EncourageShareAndDonate.tsx